import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Eyebrow } from "@/components/Reveal";

const STEPS = [
  ["Diagnose", "A short call to map where leads leak, what slows your team and which tools you already use."],
  ["Design the stack", "We pick the right modules — site, chatbot, CRM, automations — and show you a clear plan and price."],
  ["Build & connect", "We set everything up and connect it end to end, so data flows without copy-paste."],
  ["Run & improve", "We monitor, maintain and tune the system as your business grows."],
];

export const Approach = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);
  return (
    <section id="approach" ref={ref} className="relative border-t border-white/10 bg-[#0B111F] py-24 sm:py-32" data-testid="approach-section">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
        <div className="lg:col-span-5">
          <Reveal>
            <Eyebrow index="05">Our working process</Eyebrow>
            <h2 className="mt-6 font-display text-4xl font-bold leading-[1.02] tracking-tight text-white sm:text-5xl">
              Intelligence you can <span className="text-[#00F0FF]">feel</span> in the numbers.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="mt-10">
            <div className="relative aspect-[4/5] overflow-hidden rounded-[2rem] border border-white/10 clip-notch">
              <motion.img style={{ y: imgY }} src="/images/night.jpg" alt="Consultant working late on a laptop"
                className="absolute inset-0 h-[116%] w-full -top-[8%] object-cover saturate-[0.6]" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#070B14] to-transparent" />
              <div className="absolute inset-0 spotlight" />
              <p className="absolute bottom-6 left-6 right-6 font-mono text-xs uppercase tracking-[0.2em] text-slate-300">Business intelligence · Automation · AI</p>
            </div>
          </Reveal>
        </div>
        <ol className="lg:col-span-7 lg:pt-28">
          {STEPS.map(([t, d], i) => (
            <Reveal key={t} delay={i * 0.05}>
              <li className="group grid grid-cols-[auto_1fr] gap-6 border-t border-white/10 py-9 sm:gap-10" data-testid={`approach-step-${i + 1}`}>
                <span className="font-mono text-sm text-[#00F0FF]">0{i + 1}</span>
                <div>
                  <h3 className="font-display text-2xl font-bold text-white transition-transform duration-500 group-hover:translate-x-2 sm:text-4xl">{t}</h3>
                  <p className="mt-3 max-w-lg text-sm leading-relaxed text-slate-300 sm:text-base">{d}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
};
